import { 
  USER_REQUEST, USER_ERROR, USER_SUCCESS,
  CREATE_USER, UPDATE_USER, DELETE_USER,
  PROFILE_DELETE
} from '../actions/user';
import { api, errorFn } from '@/common/apiService'
import showSnackbar from '@/common/utils'

const state = { 
  status: '',
  profile: {}
};

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.username
};

const actions = {
  [USER_REQUEST]: async ({ commit }) => {
    commit(USER_REQUEST)
    await api.get('/api/auth/users/me/').then((resp) => {
      commit(USER_SUCCESS, resp.data)
    }).catch(errorFn)
  },
  [CREATE_USER]: ({commit, dispatch}, user) => {
    const body = JSON.stringify(user);
    return api.post('/users/', body).then((resp) => {
      showSnackbar({
        message:`User ${resp.data.username} created`,
        url:'',
        color:'primary', 
        timeout:10000
      })
    }).catch(errorFn)
  },
  [UPDATE_USER]: ({commit, dispatch}, user) => {
    const body = JSON.stringify(user);
    return api.put('/users/', body).then((resp) => {
      showSnackbar({
        message:`User ${resp.data.username} updated`,
        url:'',
        color:'primary', 
        timeout:10000
      })
    }).catch(errorFn)
  },
  [DELETE_USER]: ({commit, dispatch}, user) => {
    const body = JSON.stringify(user);
    return api.put('/users/', body).then((resp) => {
      showSnackbar({
        message:`User ${resp.data.username} deleted`,
        url:'',
        color:'primary', 
        timeout:10000
      })
    }).catch(errorFn)
  },
}

const mutations = {
  [USER_REQUEST]: state => {
    state.status = "loading";
  },
  [USER_SUCCESS]: (state, user) => {
    state.status = 'success'
    state.profile = {...user}
  },
  [USER_ERROR]: state => {
    state.status = "error";
  },
  [PROFILE_DELETE]: state => {
    state.profile = {}
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
